import "./ConstructionBlock.scss";
import React, { useContext } from "react";
import { languages } from "../../languages/languages";

import UserContext from "../../languages/UserContext";
const ConstructionBlock = () => {
  const handleMouseOver = (e, image) => {
    document.querySelector(".construction").classList.add(image);
  };
  const handleMouseOut = (e, image) => {
    document.querySelector(".construction").classList.remove(image);
  };

  const user = useContext(UserContext);
  return (
    <section className="construction" id="construction">
      <div
        onMouseOver={(e) => {
          handleMouseOver(e, "renovation");
        }}
        onMouseOut={(e) => {
          handleMouseOut(e, "renovation");
        }}
        className="row"
      >
        <span className="title">{languages[user.lang].Service1Header}</span>
        <p className="content">{languages[user.lang].Service1Text}</p>
      </div>
      <div
        onMouseOver={(e) => {
          handleMouseOver(e, "replacement");
        }}
        onMouseOut={(e) => {
          handleMouseOut(e, "replacement");
        }}
        className="row"
      >
        <span className="title">{languages[user.lang].Service2Header}</span>
        <p className="content">{languages[user.lang].Service2Text}</p>
      </div>
      <div
        onMouseOver={(e) => {
          handleMouseOver(e, "insulation");
        }}
        onMouseOut={(e) => {
          handleMouseOut(e, "insulation");
        }}
        className="row"
      >
        <span className="title">{languages[user.lang].Service3Header}</span>
        <p className="content">{languages[user.lang].Service3Text}</p>
      </div>
      <div
        onMouseOver={(e) => {
          handleMouseOver(e, "interior");
        }}
        onMouseOut={(e) => {
          handleMouseOut(e, "interior");
        }}
        className="row"
      >
        <span className="title">{languages[user.lang].Service4Header}</span>
        <p className="content">{languages[user.lang].Service4Text}</p>
      </div>
    </section>
  );
};

export default ConstructionBlock;
